import React from 'react';
import Image from 'next/image';
import Link from 'next/link';

const offeringItems = [
    {
        title: 'Tipp-Test',
        description: 'Teste deine Tippgeschwindigkeit und finde heraus, wie schnell du tippen kannst.',
        href: '/tipptest',
        link: 'Geschwindigkeit messen →',
        imgSrc: '/images/Geschwindigkeit-messen.png',
    },
    {
        title: 'Einführung',
        description: 'Lerne die Grundlagen des 10-Finger-Schreibens, erfahre wie du am besten damit beginnst. ',
        href: '/einfuehrung',
        link: 'Einführung ansehen →',
        imgSrc: '/images/wie-eine-rakete-durchstarten.png',
    },
    {
        title: 'Statistik',
        description: 'Verfolge deine Fortschritte und sieh dir detaillierte Statistiken zu deinem Tippen an.',
        href: '/statistik',
        link: 'In den Statistik stöbern →',
        imgSrc: '/images/Statistik.png',
    },
    {
        title: 'Pro-Version',
        description: 'Entdecke die Vorteile der Pro-Version und wie sie dir helfen kann, noch besser zu tippen.',
        href: '/pro',
        link: 'Pro-Version entdecken →',
        imgSrc: '/images/Pro-Version-kaufen.png',
    },
    {
        title: 'Blog',
        description: 'Lies interessante Artikel und Tipps rund ums Tippen und Tastaturschreiben.',
        href: '/blog',
        link: 'Zum Blog →',
        imgSrc: '/images/Doktorhut.png',
    },
];

const Offerings = () => (
    <section className="my-10 px-4 md:px-10 lg:px-20">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-6">
            {offeringItems.map((item, index) => (
                <div
                    key={index}
                    className="bg-gray-100 p-6 rounded-lg shadow-md hover:bg-white transition duration-300 relative group"
                >
                    <div className="absolute top-4 left-4 p-2 rounded-md" style={{ width: '40px', height: '40px' }}>
                        <Image 
                            src={item.imgSrc} 
                            alt={`${item.title} icon`} 
                            width={40} 
                            height={40}
                            loading={index < 2 ? "eager" : "lazy"}
                        />
                    </div>
                    <h3 className="text-xl font-semibold mb-2 mt-12 text-left" style={{fontFamily: '"Courier Prime", monospace'}}>{item.title}</h3>
                    <p className="text-gray-600 text-left">{item.description}</p>
                    <Link 
                        href={item.href}
                        className="text-blue-600 hover:underline mt-4 block text-left opacity-0 group-hover:opacity-100 transition-opacity duration-300 h-6"
                        aria-label={`${item.link} für ${item.title}`}
                    >
                        {item.link}
                    </Link>
                </div>
            ))}
        </div>
    </section>
);

export default Offerings;
